import { useNavbarBackground } from "@/contexts/NavbarBackgroundContext";
import { useEffect } from "react";

/**
 * Custom hook to control the navbar background color.
 * Sets the navbar color on mount and resets it on unmount.
 *
 * @param colorOnMount - The color to set when the component mounts
 * @param colorOnUnmount - The color to set when the component unmounts (defaults to "transparent")
 *
 * @example
 * // Set white navbar that resets to transparent
 * useControlNavbarColor(Colors.WHITE);
 *
 * @example
 * // Set gradient navbar that resets to transparent
 * useControlNavbarColor(`linear-gradient(to right, ${Colors.WHITE} 0%, ${Colors.WHITE} 33%, ${Colors.ALMOST_WHITE} 33%, ${Colors.ALMOST_WHITE} 100%)`);
 *
 * @example
 * // Set white navbar that resets to gray
 * useControlNavbarColor(Colors.WHITE, Colors.GRAY);
 */
export function useControlNavbarColor(colorOnMount: string, colorOnUnmount: string = "transparent") {
  const { setNavbarBackground } = useNavbarBackground();

  useEffect(() => {
    console.info("setting color on mount to: ", colorOnMount);
    setNavbarBackground(colorOnMount);
    return () => {
      console.info("resetting color on unmount to: ", colorOnUnmount);
      setNavbarBackground(colorOnUnmount);
    };
  }, [colorOnMount, colorOnUnmount, setNavbarBackground]);
}
